export default {
    qiniuDomain: "https://qiniu.youskt.com/",
}